import React, { useState, useEffect } from "react";
import "./likeButton.css";
import { AiFillLike, AiOutlineLike } from "react-icons/ai";
import axios from "axios";
import dummy_response from "../../dummy_data/like_response.json";
import { delay } from "../../modules/setTimeout";

interface LikeButtonProps {
  postId: string;
  currentUser: any;
  className?: string;
  onLikeChange?: (likes: string[]) => void; 
}

const LikeButton: React.FC<LikeButtonProps> = ({
  postId,
  currentUser,
  className,
  onLikeChange,
}) => {
  const [isLiked, setIsLiked] = useState(false);
  const [likeCount, setLikeCount] = useState(0);

  useEffect(() => {
    const checkUserLikedPost = async () => {
      try {
        let response;
        if (process.env.NODE_ENV === "production") {
          // For testing purposes use dummy data = development
          await delay(1000);
          response = dummy_response;
        } else {
          response = await axios.get(
            `${process.env.REACT_APP_BASE_URL}/posts/${postId}`,
            { headers: { Authorization: `Bearer ${currentUser?.token}` } }
          );
        }
        const isLiked =
          response.data.likes.filter(
            (userLikedID: string) => userLikedID == currentUser.userId
          ).length > 0;
        setIsLiked(isLiked);
        setLikeCount(response.data.likes.length);
      } catch (error) {
        console.error("Error checking if user liked post:", error);
      }
    };
    if (currentUser) {
      checkUserLikedPost();
    }
  }, []);

  const handleLikeClick = async () => {
    if (!currentUser) return;

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/posts/${postId}/like`,
        {},
        { headers: { Authorization: `Bearer ${currentUser?.token}` } }
      );

      const updatedLikes: string[] = response.data.likes;
      setIsLiked(true);
      setLikeCount(updatedLikes.length);
      if (onLikeChange) {
        onLikeChange(updatedLikes);
      }
    } catch (error) {
      console.error("Error liking post:", error);
    }
  };

  return (
    <div className={`like-button-container ${className}`}>
      <button
        className={`btn sm like ${className}`}
        onClick={handleLikeClick}
        disabled={isLiked}
      >
        {isLiked ? <AiFillLike /> : <AiOutlineLike />}
      </button>
      {/* <span className={`like-count ${className}`}>{likeCount}</span>  */}
    </div>
  );
};

export default LikeButton;
